import {
  API_CALL_FAILURE,
  API_CALL_REQUEST,
  API_CALL_SUCCESS,
  SET_SALES_COPILOT_OFFER_STAY,
  SET_SALES_COPILOT_PACKAGE_UPGRADED,
} from 'actions/actionConstants'
import {
  FETCH_SPOOF_LAUNCHPAD_OFFER_VIEWS,
  FETCH_SPOOF_USER_CARTS,
  USER_LOGOUT,
} from 'actions/apiActionConstants'
import { apiReducerSwitch, createAppReducer } from 'lib/redux/reducerUtils'

export const initialAiOpsState: App.AiOpsState = {
  userCarts: {
    carts: [],
    state: 'initial',
  },
  offerViews: {
    offers: [],
    state: 'initial',
  },
  salesCopilot: {
    packageUpgraded: false,
  },
}

const apiCalls = apiReducerSwitch<App.AiOpsState>({
  [FETCH_SPOOF_USER_CARTS]: {
    // A refresh for the same customer keeps what is already on screen.
    request: (state, action) => ({
      userCarts: {
        carts: state.userCarts.cacheKey === action.cacheKey ? state.userCarts.carts : [],
        state: 'loading',
        error: undefined,
        cacheKey: action.cacheKey,
        requestedAt: action.requestedAt,
      },
    }),
    success: (_, action) => ({
      userCarts: {
        carts: action.data.carts,
        state: 'done',
        error: undefined,
        cacheKey: action.cacheKey,
        requestedAt: action.requestedAt,
      },
    }),
    failure: (_, action) => ({
      userCarts: {
        carts: [],
        state: 'error',
        error: action.error,
        cacheKey: action.cacheKey,
        requestedAt: action.requestedAt,
      },
    }),
  },
  [FETCH_SPOOF_LAUNCHPAD_OFFER_VIEWS]: {
    // A refresh for the same customer keeps what is already on screen.
    request: (state, action) => ({
      offerViews: {
        offers: state.offerViews.cacheKey === action.cacheKey ? state.offerViews.offers : [],
        state: 'loading',
        error: undefined,
        cacheKey: action.cacheKey,
        requestedAt: action.requestedAt,
      },
    }),
    success: (_, action) => ({
      offerViews: {
        offers: action.data,
        state: 'done',
        error: undefined,
        cacheKey: action.cacheKey,
        requestedAt: action.requestedAt,
      },
    }),
    failure: (_, action) => ({
      offerViews: {
        offers: [],
        state: 'error',
        error: action.error,
        cacheKey: action.cacheKey,
        requestedAt: action.requestedAt,
      },
    }),
  },
  [USER_LOGOUT]: {
    success: () => initialAiOpsState,
  },
})

const aiOpsReducer = createAppReducer<App.AiOpsState>(initialAiOpsState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [SET_SALES_COPILOT_OFFER_STAY]: (state, action) => ({
    salesCopilot: { ...state.salesCopilot, offerStay: action.offerStay },
  }),
  [SET_SALES_COPILOT_PACKAGE_UPGRADED]: (state, action) => ({
    salesCopilot: {
      ...state.salesCopilot,
      packageUpgradeOfferId: action.offerId,
      packageUpgraded: action.packageUpgraded,
    },
  }),
})

export default aiOpsReducer
